export default __webpack_public_path__ + "9a0442904055d69477e32837c180ec87.svg";